import { Cog, Rocket, Target, Users } from 'lucide-react';
import { WHAT_WE_DO } from '@/data/about';
import { SectionHeader } from '../SectionHeader';
import { ServiceCard } from '../ServiceCard';
import { Reveal } from '../Reveal';

const ITEM_ICONS = { cog: Cog, users: Users, target: Target, rocket: Rocket };

export const WhatWeDo = () => (
  <section aria-labelledby="what-we-do-heading" data-testid="what-we-do-section" className="bg-white py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeader
        index="04"
        eyebrow={WHAT_WE_DO.eyebrow}
        title={WHAT_WE_DO.heading}
        description={WHAT_WE_DO.intro}
        testid="what-we-do-header"
      />

      <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {WHAT_WE_DO.items.map((item, i) => (
          <Reveal key={item.id} delay={i * 0.08} className="h-full">
            <ServiceCard
              name={item.name}
              color={item.color}
              description={item.tagline}
              href={item.href}
              icon={ITEM_ICONS[item.icon]}
              testid={`what-we-do-card-${item.id}`}
              linkTestid={`what-we-do-link-${item.id}`}
            />
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15}>
        <p data-testid="what-we-do-statement" className="mt-14 text-center font-serif text-2xl font-medium italic text-navy-900 sm:text-3xl">
          “{WHAT_WE_DO.statementA} <span className="text-gold-700">{WHAT_WE_DO.statementAccent}</span>”
        </p>
      </Reveal>
    </div>
  </section>
);
